// extracted by mini-css-extract-plugin
export var offsetCards = "flex-module--offset-cards--33b27";
export var removeTopMargin = "flex-module--remove-top-margin--43d51";